<script lang="ts">
  // The Settings row for the sync of review marks with GitHub's per-file
  // "Viewed" checkbox (state/viewedSync.svelte.ts): the switch, what the
  // sync does in each direction, and how it stands (a change that did not
  // save; GitHub refusing it, or files that failed, on the pull request
  // last looked at).
  import SettingRow from './SettingRow.svelte';
  import Switch from './Switch.svelte';
  import { refusalText, type SettingsState, type ViewedHealth } from '../state/settings/program';

  interface Props {
    /** On or off; null while the user's choice is not known. */
    choice: boolean | null;
    saving: boolean;
    refused: SettingsState['refused'];
    health: ViewedHealth | null;
    onchange: (on: boolean) => void;
  }
  let { choice, saving, refused, health, onchange }: Props = $props();
</script>

<SettingRow id="github-viewed" name="Mark files as Viewed on GitHub">
  {#snippet description()}
    When you have reviewed every change in a file here, Changeling ticks “Viewed” for it on GitHub, and unticks it when you unmark any of them. A file you
    tick “Viewed” on GitHub is marked reviewed here; unticking it there changes nothing here.
  {/snippet}
  {#snippet control({ labelId, descId })}
    <Switch on={choice === true} labelledby={labelId} describedby={descId} disabled={choice === null} busy={saving} {onchange} />
  {/snippet}
  {#snippet notes()}
    <p class="setting-saving" role="status">{saving ? 'Saving…' : ''}</p>
    {#if refused}
      <p class="setting-problem" role="alert">{refusalText(refused)}</p>
    {/if}
    {#if choice === true && health?.paused}
      <p class="setting-warning" role="status">
        GitHub won’t let Changeling set “Viewed” on <a href={health.path}>{health.pr}</a> ({health.paused}), so files of that repository are not synced until the page
        reloads.
      </p>
    {:else if choice === true && health?.errors}
      <p class="setting-warning" role="status">
        {health.errors === 1 ? '1 file' : `${health.errors} files`} on <a href={health.path}>{health.pr}</a> did not sync with GitHub’s “Viewed”. Retry from that pull
        request’s file list.
      </p>
    {/if}
  {/snippet}
</SettingRow>
